(function ($) {
  // Holiday shop Mobile v1
  holidayShopMobileV1 = {
    formatter: $('.holiday-shop-mobile-v1')
  };

  Drupal.behaviors.holidayShopMobileV1 = {
    get: function (key) {
      return holidayShopMobileV1[key];
    },

    set: function (key, val) {
      holidayShopMobileV1[key] = val;
    },

    attach: function (context, settings) {
      if ($('body').hasClass('device-mobile')) { // only if on mobile site...
        // Init site.mpp
        site.mpp.data = {
          category: page_data['category-input-type'].categories[0],
          categories: page_data['category-input-type'].categories
        };
        site.mpp.init();

        var self = this;
        var formatter = self.get('formatter');
        var undef;

        $('li[data-productid]', context).each(function () {
          var product = $(Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid'))).filter(function () {
            return this.priceRange !== undef;
          })[0];

          if (product !== undef) {
            $('.holiday-range', $(this)).html(product.priceRange);
          } else {
            var product = $(Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid'))).filter(function () {
              return this.skus !== undef && this.skus.length > 0;
            })[0];

            $('.holiday-range', $(this)).html(product.skus[0].formattedPrice);
          }
        });
        var isDisplayableSku = $(product.skus).filter(function () {
          var undef;
          var sku = $(document).data(this.SKU_ID);

          return typeof site.features.spp_displayable_status !== 'undefined'
            && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
        })[0];

        $(document).on('inventory_status_stored', function () {
          // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
          $(page_data['category-input-type'].categories[0].products).each(function (i, product) {
            var isOrderableSku = $(product.skus).filter(function () {
              if (typeof $(document).data(this.SKU_ID) != 'undefined') {
                return ($(document).data(this.SKU_ID).isOrderable == 1) || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3);
              }
            })[0];

            if (typeof isOrderableSku == 'undefined' && !isDisplayableSku) {
              // remove product - removed completely so the quickshop positioning remains correct
              $('li.mpp-box[data-productid="' + product.PRODUCT_ID + '"]').remove();
            }
          });
        });
      }
    }
  };
})(jQuery);
